import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@apollo/orbit';
import React, { useMemo, useState } from 'react';

import { EditorActions } from 'src/app/graph/documentationPage/sdlPage/editorActions/EditorActions';
import {
  SDLDisplay,
  SchemaInfo,
} from 'src/app/graph/documentationPage/sdlPage/sdlDisplay/SDLDisplay';
import { useGraphRef } from 'src/app/graph/hooks/useGraphRef';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  schemaInfo: SchemaInfo;
}

export const FieldPageSDLModal = ({ isOpen, onClose, schemaInfo }: Props) => {
  // TODO: update this function to compute a proper supergraph or subgraph when needed.
  const { schemaInfoMap, name } = useMemo(() => {
    const { id } = schemaInfo;
    return {
      schemaInfoMap: { [id]: schemaInfo },
      name: id,
    };
  }, [schemaInfo]);

  const graphRef = useGraphRef();
  const [showComments, setShowComments] = useState(true);
  const [showDeprecated, setShowDeprecated] = useState(true);

  return (
    <Modal isOpen={isOpen} size="5xl" onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody className="p-0 first:pt-0">
          <SDLDisplay
            // TODO: properly map these following properties.
            buildErrors={[]}
            schemaInfoMap={schemaInfoMap}
            selectedSchemaName={name}
            className="h-[65vh] *:rounded-none *:border-0 *:border-b"
            editorActions={
              <EditorActions
                selectedSchemaInfo={schemaInfo}
                setShowComments={setShowComments}
                showComments={showComments}
                setShowDeprecated={setShowDeprecated}
                showDeprecated={showDeprecated}
                setKeyboardModalVisible={() => {}}
                graphRef={graphRef}
                hasSubgraphs={true}
                selectedSchemaName={
                  // FieldPageSDLModal is only used to show supergraph schema.
                  null
                }
              />
            }
            selectedSchemaInfo={schemaInfo}
            showComments={showComments}
            showDeprecated={showDeprecated}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" type="button" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
